import { render, staticRenderFns } from "./DocketSnippet.vue?vue&type=template&id=5aa64774&"
import script from "./DocketSnippet.vue?vue&type=script&lang=js&"
export * from "./DocketSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports